/*eslint-disable*/
import $urls from '../urls/url';
import $api from '../axios/index';
import $qs from 'qs';
import $Cookies from 'js-cookie';
import { agentCodeFromUrl, getInitAgentCode } from './initAgentCode';
import { store } from '../../common/index';
import { MessageBox,Conf } from 'element-ui';

// 图片为jpg的老虎机图片
const jpgArr = ['mg','dt','jdb'];
// let lang = $Cookies.get('lang');

const CryptoJS = require('crypto-js');  //引用AES源码js
const key = CryptoJS.enc.Utf8.parse("1234123412ABCDEF");  //十六位十六进制数作为密钥
const iv = CryptoJS.enc.Utf8.parse('ABCDEF1234123412');   //十六位十六进制数作为密钥偏移量

const commonJS = {
  //解密方法
  Decrypt(word) {
    let encryptedHexStr = CryptoJS.enc.Hex.parse(word);
    let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    let decrypt = CryptoJS.AES.decrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return decryptedStr.toString();
  },

  //加密方法
  Encrypt(word) {
    let srcs = CryptoJS.enc.Utf8.parse(word);
    let encrypted = CryptoJS.AES.encrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.ciphertext.toString().toUpperCase();
  },
  
  // 注册页代理代码存cookies,链接带有代理代码就存cookies,否则就冲cookies里取，
  getAgentCodeByCookies() {
    return $Cookies.get('agentCode')
  },
  setAgentCodeInCookies(code) {
    $Cookies.set('agentCode', code, { expires: 1 })
  },
  getAgentCode() {
    const agentCode = agentCodeFromUrl();
    // 初始化归因独立保存，不随注册成功或退出登录清除 agentCode Cookie。
    const initCode = getInitAgentCode(this.getAgentCodeByCookies());
    if (agentCode) {
      try { this.setAgentCodeInCookies(agentCode); } catch (e) {}
    }
    return initCode;
  },
  // 随机字符串
  randomRange(min,max){
    var returnStr = "",
    range = (max ? Math.round(Math.random() * (max-min)) + min : min),
    arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9','a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    for(var i=0; i<range; i++){
    var index = Math.round(Math.random() * (arr.length-1));
    returnStr += arr[index];
    }
      return returnStr;
  },
  // 挂件跳转处理
  goHref(url) {
    if (!url) return;

    if(url.indexOf('.qq.com')>-1 || url.indexOf('.meiqia.com')>-1 || url.indexOf('chat.livechatvalue.com')>-1|| url.indexOf('live800')>-1) {
      window.open(url, '', 'height=500, width=600');
    } else if (url.indexOf('tencent://') === 0) {
      window.location.href = url;
    } else if(url.startsWith('/')){
      // return url.split('#')[1];
      return url
    } else {
      window.open(url)
    }
    return false;
  },

  // 支付存款链接
  depositUrl(params) {
    if(params.payType !== 'IB') {
      // 选择平台的支付方式
      window.open(`${params.payDomain}?payConfigId=${params.payConfigId}&amount=${params.amount}&payType=${params.payType}&uuId=${params.userId}`)
    }else if (params.payType === 'IB') {
      // 选择IB
      window.open(`${params.payDomain}?bankCode=${params.bankCode}&payConfigId=${params.payConfigId}&amount=${params.amount}&payType=${params.payType}&uuId=${params.userId}`)
    }
  },
  // 新支付链接
  newDepositUrl(params){
    if(params.payType !== 'IB') {
      // if(!params.amount){
      //   window.open(`${params.payDomain}?payConfigId=${params.payConfigId}&payType=${params.payType}&uuId=${params.userId}&domain=${params.domain}`)
      // }else{
      //   window.open(`${params.payDomain}?payConfigId=${params.payConfigId}&amount=${params.amount}&payType=${params.payType}&uuId=${params.userId}&domain=${params.domain}`)
      // }
      window.open(`${params.payDomain}?payConfigId=${params.payConfigId}&amount=${params.amount}&payType=${params.payType}&uuId=${params.userId}&domain=${params.domain}&remark=${params.remark}`)
      // 选择平台的支付方式
    }else if (params.payType === 'IB') {
      // 选择IB
      // if(!params.amount){
      //   window.open(`${params.payDomain}?bankCode=${params.bankCode}&payConfigId=${params.payConfigId}&payType=${params.payType}&uuId=${params.userId}&domain=${params.domain}`)
      // }else{
      //   window.open(`${params.payDomain}?bankCode=${params.bankCode}&payConfigId=${params.payConfigId}&amount=${params.amount}&payType=${params.payType}&uuId=${params.userId}&domain=${params.domain}`)
      // }
      window.open(`${params.payDomain}?bankCode=${params.bankCode}&payConfigId=${params.payConfigId}&amount=${params.amount}&payType=${params.payType}&uuId=${params.userId}&domain=${params.domain}&remark=${params.remark}`)
    }
  },
  // 支付存款链接(BK类型)
  depositBankUrl(payType,UUID,payDomain) {
    if(payType === 'BK') {
      window.open(`${payDomain}?payType=${payType}&uuId=${UUID}`)
    }
  },
  // 新支付存款链接(BK类型)
  newDepositBankUrl(payType,UUID,payDomain) {
    
      let lang = $Cookies.get('lang');
      let domain = window.location.origin
      window.open(`${payDomain}?payType=${payType}&uuId=${UUID}&domain=${domain}&lang=${lang}`)
  },


  // 设置copyright 年限
  setCopyright() {
    return new Date().toLocaleString().split('/')[0]
  },
  loginOut() {
    store.dispatch('checkLogin');
    let UUID = $Cookies.get('UUID');
    if(UUID){
      return new Promise((resolve, reject) => {
        $api.post($urls.USER.LOGINOUT, {UUID:UUID}, (resp) => {
          if(resp.data.code===200){
            $Cookies.remove('UUID');
            store.dispatch('checkLogin');
            resolve(resp.data.msg)
          }else {
            reject(resp.data.msg);
          }
        }, err => {
          reject(err.message);
        })
      })
    }
  },
  serverInfo() {
    return new Promise((resolve, reject) => {
      $api.post($urls.HOMEBEFORE.serverInfo, {}, (resp) => {
        if(resp.data.code===200){
          let serverInfo = resp.data.data.serverInfo;
          let picLink = serverInfo.ftpDomain;
          resolve(picLink)
        }else {
          reject(resp.data.msg);
        }
      }, err => {
        reject(err.message);
      })
    })
  },
  // 获取游戏平台图片
  platformPicInfo(frontType,gameType) {
    return new Promise((resolve, reject) => {
      let params = {
        frontType : frontType,
        gameType : gameType,
      };
      $api.post($urls.HOMEBEFORE.platformPicInfo, params, (resp) => {
        if (resp.data.code === 200) {
          let platformPicInfo = resp.data.data;
          resolve(platformPicInfo)
        }else {
          resolve([]);
        }
      }, (err) => {
        reject(err.message);
      })
    })
  },
  // 获取平台游戏
  gamePlatformOther(gameType) {
    return new Promise((resolve, reject) => {
      let params = {
        gameType: gameType,
        pageNo: 1,
        pageSize: 10,
      };
      $api.post($urls.GAME.gamePlatform, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data.list;
          resolve(data)
        }else {
          reject(resp.data.msg);
        }
      }, (err) => {
        reject(err.message);
      })
    })
  },
  // 游戏平台图片拼接
  platformPicjoint(picArr,gameArr) {
    if(gameArr.length>0) {
      for (let key of gameArr) {
        for (let picKey of picArr){
          if(key.platformKey===picKey.platformKey) {
            key['logoPic'] = picKey.logoPic;
            key['logoImg'] = picKey.logoImg;
          }
        }
      }
      return gameArr
    }else {
      return gameArr
    }
  },

  // 老虎机平台
  gamePlatform() {
    return new Promise((resolve, reject) => {
      let gameType = 1;
      let pageNo = 1;
      let pageSize = 20;
      let params = {
        gameType: gameType,
        pageNo: pageNo,
        pageSize: pageSize,
      };
      $api.post($urls.GAME.gamePlatform, params, (resp) => {
        if (resp.data.code === 200) {
          let gameForm = resp.data.data.list;
          resolve(gameForm)
        }else {
          reject(resp.data.msg);
        }
      }, (err) => {
        reject(err.message);
      })
    })
  },
  getMyslot(UUID) {
    return new Promise((resolve, reject) => {
      let datas = [];
      let params = {
        frontType: 0,
        UUID: UUID,
        pageNo: -1,
        pageSize: 0,
      };
      if (UUID) {
        $api.post($urls.SLOT.mySlot, params, resp => {
          if ( resp.data.code === 200 || resp.data.code === 201) {

            if(resp.data.data===null||resp.data.data===undefined){
              datas=[]
            }else {
              datas = resp.data.data.list;
            }
          }else if(resp.data.success===false){}
          resolve(datas)
        }, err => {
          reject(err.message);
        })
      }
    });
  },


  // 老虎机拼接
  // 收藏的游戏拼接
  slotJoint(picLink,resp) {// 收藏
    let data = resp;
    if(data===null||data===[]){
      data = [];
      return data
    }else {
      data.forEach((item) => {
        // if(item.platformCode==='HB'){
        //   item['picLink'] = picLink + 'game/' + item.platformCode + '/' + item.gameId + '_zh-CN.png';
        // }else if(jpgArr.includes(item.platformCode.toLowerCase())){
        //   item['picLink'] = picLink + 'game/' + item.platformCode + '/' + item.gameId + '.jpg';
        // }else {
        //   item['picLink'] = picLink + 'game/' + item.platformCode + '/' + item.gameId + '.png';
        // }
        item['picLink'] = picLink + item.pcImg;
        item['collect'] = true;
      });
      return data
    }
  },
  // 分页的拼接
  joint(picLink, gameList, mySlot) {

    let data = gameList;
    if (mySlot === null || mySlot === [] || mySlot === undefined) {
      mySlot = [];
    }
    if (data === null || data === []) {
      data = [];
      return data
    } else {

      data.forEach((item) => {
        // if (item.platformCode === 'HB') {
        //   item['picLink'] = picLink + 'game/' + item.platformCode + '/' + item.gameId + '_zh-CN.png';
        // } else if (jpgArr.includes(item.platformCode.toLowerCase())) {
        //   item['picLink'] = picLink + 'game/' + item.platformCode + '/' + item.gameId + '.jpg';
        // } else {
        //   item['picLink'] = picLink + 'game/' + item.platformCode + '/' + item.gameId + '.png';
        // }
        item['picLink'] = picLink + item.pcImg;
      });

      data.forEach((gamesItem) => {
        mySlot.forEach((myItem) => {
          if (gamesItem.id === myItem.id) {
            gamesItem['collect'] = true;
          }
        })
      });
      return data
    }
  },

  // 维护游戏判断(判断当前平台是否在维护)
  isMaintainGame (platformKey) {
    let maintainList = store.state.maintain_game_platform_list;
    if (!maintainList.length) return false;
    for (let i = 0;i<maintainList.length;i++) {
      if(maintainList[i].platformKey ===platformKey) {
        store.dispatch('maintainGameInfo', maintainList[i].maintainRemarks);
        store.dispatch('maintainGameState', true);
        return true;
      }
    }
    return false;
  },

  // 进入老虎机游戏
  slotGoGame(item,isLogin,UUID) {
    
    let lang = $Cookies.get('lang');
    let isMaintain =  this.isMaintainGame(item.fullName);
    if(isMaintain) return;

    let gameType = item.gameType ? item.gameType : 1;
    let src = isLogin ? '/game/forward' : '/game/guest/forward' ;
    let href =  `/api${src}?UUID=${UUID}&linkType=0&platformCode=${item.platformCode}&platformKey=${item.fullName}&gameType=${gameType}&gameCode=${item.gameId}&lang=${lang}`;
    if (isLogin) {
      window.open(href)
    } else {
      this.goGameTip()
    }
  },
  // wns进入老虎机游戏

  slotTryGame(item) {
    
    let lang = $Cookies.get('lang');
    let isMaintain =  this.isMaintainGame(item.fullName);
    if(isMaintain) return;

    let gameType = 1;
    let src = '/game/guest/forward' ;
    let href =  `/api${src}?linkType=0&platformCode=${item.platformCode}&platformKey=${item.fullName}&gameType=${gameType}&gameCode=${item.gameId}&lang=${lang}`;
    this.tryGameTip(href)
  },
  // 国际化
  INslotTryGame(item,obj) {
    
    let lang = $Cookies.get('lang');
    let isMaintain =  this.isMaintainGame(item.fullName);
    if(isMaintain) return;

    let gameType = 1;
    let src = '/game/guest/forward' ;
    let href =  `/api${src}?linkType=0&platformCode=${item.platformCode}&platformKey=${item.fullName}&gameType=${gameType}&gameCode=${item.gameId}&lang=${lang}`;
    this.INtryGameTip(href,obj)
  },
  INtryGameTip(url,obj) {
    MessageBox.confirm(obj.title, obj.tips, {
      confirmButtonText: obj.confirmButtonText,
      cancelButtonText:  obj.cancelButtonText,
      type: 'warning'
    }).then(() => {
      window.open(url)
    }).catch(() => {

    });
  },
  // 游戏提示
  goGameTip() {
    return new Promise((resolve, reject) => {
      MessageBox.alert('登录后才能进行游戏', '温馨提示', {
        confirmButtonText: '确定',
        type: 'warning',
        callback: action => {
          resolve(action)
        }
      })
    })
  },
  tryGameTip(url) {
    MessageBox.confirm('试玩没有任何奖励, 是否继续?', '温馨提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      window.open(url)
    }).catch(() => {

    });
  },
  IfarmrGoGame(item,isLogin,UUID) {
    let lang = $Cookies.get('lang');
    let isMaintain =  this.isMaintainGame(item.platformKey);   // 游戏是否在维护
    if(isMaintain) return;
    let src = isLogin ? '/game/forward' : '/game/guest/forward' ;
    let href =  `/api${src}?UUID=${UUID}&linkType=0&platformCode=${item.platformCode}&platformKey=${item.platformKey}&gameType=${item.gameType}&lang=${lang}`;
    if(isLogin) return href
    else return ''
  },
  // 其他游戏   
  goGame(item,isLogin,UUID,isTips) {
    let lang = $Cookies.get('lang');
    let isMaintain =  this.isMaintainGame(item.platformKey);
    if(isMaintain) return;
    let src = isLogin ? '/game/forward' : '/game/guest/forward' ;
    let href =  `/api${src}?UUID=${UUID}&linkType=0&platformCode=${item.platformCode}&platformKey=${item.platformKey}&gameType=${item.gameType}&lang=${lang}`;
    if (isLogin) {
      window.open(href)
    } else {
      if(!isTips){
        this.goGameTip()
      }else{
        
      }
    }
  },
  // 威尼斯新打开游戏
  gownsGame(item,isLogin,UUID){
    let isMaintain =  this.isMaintainGame(item.platformKey);
    if(isMaintain) return;




  },
  // 跳热门游戏（包括棋牌老虎机）
  goHotGame(item,isLogin,UUID){
    
    let lang = $Cookies.get('lang');
    if(isLogin) {
      // 跳游戏
      if((!item.hasOwnProperty('gameType')||item.gameType==='1'||item.gameType==='6') && item.hasOwnProperty('gameId')){

        let isMaintain =  this.isMaintainGame(item.fullName);
        if(isMaintain) return;
        let gameType
        if(item.fullName.indexOf('SLOT')==-1){
          gameType = '6'
        }else{
          gameType = '1'
        }
        // 具体游戏，老虎机/棋牌等
        // let gameType = item.gameType ? item.gameType : 1;
        let src = isLogin ? '/game/forward' : '/game/guest/forward' ;
        let href =  `/api${src}?UUID=${UUID}&linkType=0&platformCode=${item.platformCode}&platformKey=${item.fullName}&gameType=${gameType}&gameCode=${item.gameId}&lang=${lang}`;
        window.open(href)
      }else {

        let isMaintain =  this.isMaintainGame(item.platformKey);
        if(isMaintain) return;

        let src = isLogin ? '/game/forward' : '/game/guest/forward' ;
        let href =  `/api${src}?UUID=${UUID}&linkType=0&platformCode=${item.platformCode}&platformKey=${item.platformKey}&gameType=${item.gameType}&lang=${lang}`;
        window.open(href)
      }
    } else {
      this.goGameTip()
      
    }
  },
  tryGame(item) {
    
    let lang = $Cookies.get('lang');
    let isMaintain =  this.isMaintainGame(item.platformKey);
    if(isMaintain) return;

    let src = '/game/guest/forward' ;
    let href =  `/api${src}?linkType=0&platformCode=${item.platformCode}&platformKey=${item.platformKey}&gameType=${item.gameType}&lang=${lang}`;
    this.tryGameTip(href)
  },

  // 金沙 点击提示登录 jinsha_GoGame
  jinsha_GoGame(item,isLogin,UUID) {
    let lang = $Cookies.get('lang');
    if(isLogin) {
      // 跳游戏
      if((!item.hasOwnProperty('gameType')||item.gameType==='1'||item.gameType==='6') && item.hasOwnProperty('gameId')){

        let isMaintain =  this.isMaintainGame(item.fullName);
        if(isMaintain) return;

        // 具体游戏，老虎机/棋牌等
        let gameType = item.gameType ? item.gameType : 1;
        let src = isLogin ? '/game/forward' : '/game/guest/forward' ;
        let href =  `/api${src}?UUID=${UUID}&linkType=0&platformCode=${item.platformCode}&platformKey=${item.fullName}&gameType=${gameType}&gameCode=${item.gameId}&lang=${lang}`;
        window.open(href)
      }else {

        let isMaintain =  this.isMaintainGame(item.platformKey);
        if(isMaintain) return;

        let src = isLogin ? '/game/forward' : '/game/guest/forward' ;
        let href =  `/api${src}?UUID=${UUID}&linkType=0&platformCode=${item.platformCode}&platformKey=${item.platformKey}&gameType=${item.gameType}&lang=${lang}`;
        window.open(href)
      }
    } else {

      // 跳内页
      let targetUrl = `${window.location.origin}/login`;
      if(typeof item === 'string') {
        item = encodeURIComponent(item);
        targetUrl += '?r'+item;
        this.openWindow(targetUrl,'', 1288,896);
        return;
      }


      // 跳游戏
      let gameUrl = '';
      if((!item.hasOwnProperty('gameType')||item.gameType==='1'||item.gameType==='6') && item.hasOwnProperty('gameId')){
        // 具体游戏，老虎机/棋牌等
        let isMaintain =  this.isMaintainGame(item.fullName);
        if(isMaintain) return;

        let gameType = item.gameType ? item.gameType : 1;
        gameUrl =  `/api/game/forward?linkType=0&platformCode=${item.platformCode}&platformKey=${item.fullName}&gameType=${gameType}&gameCode=${item.gameId}&lang=${lang}`;
      }else {

        let isMaintain =  this.isMaintainGame(item.platformKey);
        if(isMaintain) return;

        gameUrl =  `/api/game/forward?linkType=0&platformCode=${item.platformCode}&platformKey=${item.platformKey}&gameType=${item.gameType}&lang=${lang}`;
      }
      gameUrl = encodeURIComponent(gameUrl);
      targetUrl += '?' + gameUrl;
      this.openWindow(targetUrl,'', 1288,896)
    }
  },
  // 威尼斯 点击提示登录 wns_GoGame
  wns_GoGame(item,isLogin,UUID) {
    
    let lang = $Cookies.get('lang');
    if(isLogin) {
      // 跳游戏
      if((!item.hasOwnProperty('gameType')||item.gameType==='1'||item.gameType==='6') && item.hasOwnProperty('gameId')){

        let isMaintain =  this.isMaintainGame(item.fullName);
        if(isMaintain) return;

        // 具体游戏，老虎机/棋牌等
        let gameType = item.gameType ? item.gameType : 1;
        let src = isLogin ? '/game/forward' : '/game/guest/forward' ;
        let href =  `/api${src}?UUID=${UUID}&linkType=0&platformCode=${item.platformCode}&platformKey=${item.fullName}&gameType=${gameType}&gameCode=${item.gameId}&lang=${lang}`;

        if(item.showLogin=='true'){
          // console.log(href)
          window.location.href = href
        }else{
          window.open(href)
        }

       
      }else {

        let isMaintain =  this.isMaintainGame(item.platformKey);
        if(isMaintain) return;

        let src = isLogin ? '/game/forward' : '/game/guest/forward' ;
        let href =  `/api${src}?UUID=${UUID}&linkType=0&platformCode=${item.platformCode}&platformKey=${item.platformKey}&gameType=${item.gameType}&lang=${lang}`;
        if(item.showLogin=='true'){
          window.location.href = href
        }else{
          window.open(href)
        }
      }
    } else {
      store.commit('setShowLoginBox',true)
      // // 跳内页
      // var targetUrl = `${window.location.href}`;
      // console.log(targetUrl.indexOf())
      // if(targetUrl.indexOf('?')>-1){
      //   targetUrl = targetUrl.slice(0,targetUrl.indexOf('?'))
      // }

      // // if(typeof item === 'string') {
      // //   item = encodeURIComponent(item);
      // //   targetUrl += '?r'+item;
      // //   this.openWindow(targetUrl,'', 1288,896);
      // //   return;
      // // }


      // // 跳游戏
      // let gameUrl = '';
      // if((!item.hasOwnProperty('gameType')||item.gameType==='1'||item.gameType==='6') && item.hasOwnProperty('gameId')){
      //   // 具体游戏，老虎机/棋牌等
      //   let isMaintain =  this.isMaintainGame(item.fullName);
      //   if(isMaintain) return;

      //   let gameType = item.gameType ? item.gameType : 1;
      //   gameUrl =  `platformCode=${item.platformCode}&platformKey=${item.fullName}&gameType=${gameType}&gameCode=${item.gameId}&showLogin=${true}`;
      // }else {

      //   let isMaintain =  this.isMaintainGame(item.platformKey);
      //   if(isMaintain) return;

      //   gameUrl =  `platformCode=${item.platformCode}&platformKey=${item.platformKey}&gameType=${item.gameType}&showLogin=${true}`;
      // }
      // // gameUrl = encodeURIComponent(gameUrl);
      // targetUrl += '?' + gameUrl;
      // this.openWindow(targetUrl,'', 1288,896)
    }
  },

  // 打开窗口并居中
  openWindow(url, name, iWidth, iHeight) {
    // url;                                 //转向网页的地址;
    // name;                           //网页名称，可为空;
    // iWidth;                          //弹出窗口的宽度;
    // iHeight;                        //弹出窗口的高度;
    var iTop = (window.screen.availHeight - 30 - iHeight) / 2; //获得窗口的垂直位置;
    var iLeft = (window.screen.availWidth - 10 - iWidth) / 2;  //获得窗口的水平位置;
    window.open(url, name, 'height=' + iHeight + ',,innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',toolbar=no,menubar=no,scrollbars=auto,resizeable=no,location=no,status=no');
  },


  // // 体育游戏投注
  // sportGoGame(item,isLogin,UUID) {
  //   let src = isLogin ? '/game/forward' : '/game/guest/forward' ;
  //   let href =  `/api${src}?UUID=${UUID}&linkType=0&platformCode=${item.platformCode}&platformKey=${item.platformKey}&gameType=${item.gameType}`;
  //   if (isLogin) {
  //     window.open(href)
  //   } else {
  //     this.sportsGoGameTip()
  //   }
  // },
  // // 体育投注提示
  // sportsGoGameTip() {
  //   return new Promise((resolve, reject) => {
  //     MessageBox.alert('登录后才能进行投注', '温馨提示', {
  //       confirmButtonText: '确定',
  //       type: 'warning',
  //       callback: action => {
  //         resolve(action)
  //       }
  //     })
  //   })
  // },

  // 优惠提示
  getBonusTip() {
    MessageBox.alert('登录后才能领取优惠', '温馨提示', {
      confirmButtonText: '确定',
      type: 'warning'
    })
  },

  // 一级导航
  nav_list_arr: [
    // 0.首页 1.真人 2. 体育 3. 老虎机 4.棋牌 5.捕鱼 6.彩票 7.个人中心 8.优惠
    '/home','/game/liveCasino','/game/sports','/game/slotMachine','/game/chess','/game/catchFish','/game/lottery',
    '/club','/discounts'
  ],
  // 首页导航
  sortIndexNav(type) {
    // 0.首页 1.真人 2. 体育 3. 老虎机 4.棋牌 5.捕鱼 6.彩票 7.个人中心 8.优惠
    switch (type){
      case 0:
        return this.nav_list_arr[type];
      case 1:
        return this.nav_list_arr[type];
      case 2:
        return this.nav_list_arr[type];
      case 3:
        return this.nav_list_arr[type];
      case 4:
        return this.nav_list_arr[type];
      case 5:
        return this.nav_list_arr[type];
      case 6:
        return this.nav_list_arr[type];
      case 7:
        return this.nav_list_arr[type];
      case 8:
        return this.nav_list_arr[type];
    }
  },





  safetyIndex(emailValid,mobileValid,nameValid,withdrawPasswordValid) {
    let number = 4;
    let count = 0;
    let sum = 100;
    let unit = 25;
    if(emailValid){
      count += unit;
      number--
    }
    if(mobileValid){
      count += unit;
      number--
    }
    if(nameValid){
      count += unit;
      number--
    }
    if(withdrawPasswordValid){
      count += unit;
      number--
    }
    count = (count/sum)*100;
    if(count===0) {
      count = 20;
    }
    if(count===100) {
      count -= 1;
    }
    return {count:count,number:number}
  },
  //浏览器类型及版本
  getBrowserInfo() {
    let agent = navigator.userAgent.toLowerCase();
    let regStr_ie = /msie [\d.]+;/gi;
    let regStr_ff = /firefox\/[\d.]+/gi
    let regStr_chrome = /chrome\/[\d.]+/gi;
    let regStr_saf = /safari\/[\d.]+/gi;
    let isIE = agent.indexOf("compatible") > -1 && agent.indexOf("msie" > -1); //判断是否IE<11浏览器
    let isEdge = agent.indexOf("edge") > -1 && !isIE; //判断是否IE的Edge浏览器
    let isIE11 = agent.indexOf('trident') > -1 && agent.indexOf("rv:11.0") > -1;
  if (isIE) {
    var reIE = new RegExp("msie (\\d+\\.\\d+);");
    reIE.test(agent);
    var fIEVersion = parseFloat(RegExp["$1"]);
    if (fIEVersion == 7) {
      return "IE/7";
    } else if (fIEVersion == 8) {
      return "IE/8";
    } else if (fIEVersion == 9) {
      return "IE/9";
    } else if (fIEVersion == 10) {
      return "IE/10";
    }
  } //isIE end
  if (isIE11) {
    return "IE/11";
  }
  //firefox
  if (agent.indexOf("firefox") > 0) {
    return agent.match(regStr_ff);
  }
  //Safari
  if (agent.indexOf("safari") > 0 && agent.indexOf("chrome") < 0) {
    return agent.match(regStr_saf);
  }
  //Chrome
  if (agent.indexOf("chrome") > 0) {
    return agent.match(regStr_chrome);
  }
},
  getUserInfo() {
    let _this = this;
    return new Promise((resolve, reject) => {
      let browser = _this.getBrowserInfo()[0];//取到完整信息
      let UUID = $Cookies.get('UUID');
      let deviceId = $Cookies.get('deviceId');

      if(deviceId===undefined||deviceId===''){
        let timeStr = new Date().getTime().toString();
        let str = Math.random().toString().slice(-6);
        deviceId = timeStr + str;
        $Cookies.set('deviceId', deviceId, { expires: 2000 });
      }
      let params = {
        UUID: UUID,
        browser:  browser,
        deviceId: deviceId,
        domain: document.domain,
        ipInfo: ' ',
      };
      $api.post($urls.USER.FIRSTUSERINFO, params, (resp) => {
        if (resp.data.code === 200) {
          let userInfo = resp.data.data;
          resolve(userInfo)
        } else {
          resp.data.msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(resp.data.msg)
        }
      }, err => {
        reject(err.message);
      })

    })
  },
  // 文章
  getArticleType() {
    return new Promise((resolve, reject) => {
      $api.post($urls.HELP.articleType,{}, resp=>{
        let data = resp.data.data;
        resolve(data)
      }, err => {reject(err.message)})
    })
  },

  getArticleListByType(typeId) {
    return new Promise((resolve, reject) => {
        let params = {
          // frontType: store.state.frontType,
          frontType: 0,
          typeId: typeId,
          pageNo: 1,
          pageSize: 20,
        };
        $api.post($urls.HELP.articleListByType, params, resp => {
          if(resp.data.code===200){
            let data = resp.data.data.list;
            resolve(data)
          }else {
            let msg = resp.data.msg ? resp.data.msg :resp.data.message;
            reject(msg)
          }
        }, err => {reject(err.message)})
    })
  },

  getBannerList(id) {
    return new Promise((resolve, reject) => {
      let params = {
        frontType: 0,
        position: id,
      };
      $api.post($urls.HOMEBEFORE.BANNERLIST,params,resp=>{
        if(resp.data.code===200){
          let data = resp.data.data.list;
          let arr =[];
          data.forEach((item)=>{
            let obj = {};
            obj['img'] = item.picLink;
            obj['title'] = item.picContent;
            arr.push(obj)
          });
          resolve(arr)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{})
    })

  },
  getFirstNavList(str) {
    return new Promise((resolve, reject) => {
      let params = {
        frontType: 2
      };
      $api.post($urls.HOMEBEFORE.FIRSTNAVLIST,params,resp=>{
        if(resp.data.code === 200){
          let id = 0;
          let data = resp.data.data;
          data.forEach((item)=>{
            if(item.navName===str){
              id = item.id;
            }
          });
          resolve(id)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{})
    });
  },

  // 登陆信息
  logedUserInfo() {
    const _this = this;
    let browser = this.getBrowserInfo()[0];
    let UUID = $Cookies.get('UUID');
    let deviceId = $Cookies.get('deviceId');
    if(deviceId===undefined||deviceId===''){
      let timeStr = new Date().getTime().toString();
      let str = Math.random().toString().slice(-6);
      deviceId = timeStr + str;
      $Cookies.set('deviceId', deviceId, { expires: 2000 });
    }

    let params = {
      UUID: UUID,
      browser:  browser,
      deviceId: deviceId,
      // domain: document.domain,
      // ipInfo: ' ',
    };

    $api.post($urls.HOMEAFTER.logedUserInfo, params, (resp) => {
      if (resp.data.code === 200) {
        let userInfo = resp.data.data;
        store.commit('SET_USER_INFO',userInfo);
        // 没有填写手机  弹框
        userInfo.userInfo.mobilePhone == '' || userInfo.userInfo.mobilePhone == null ? store.commit('setshowBindphone',true):store.commit('setshowBindphone',false)
        _this.deviceInfo();
      } else {}
    }, err => {})

  },

  getOsInfo() {
    var userAgent = navigator.userAgent.toLowerCase();
    var name = 'Unknown';
    var version = "Unknown";
    if(userAgent.indexOf("win") > -1) {
      name = "Windows";
      if(userAgent.indexOf("windows nt 5.0") > -1) {
        version = "Windows 2000";
      } else if(userAgent.indexOf("windows nt 5.1") > -1 || userAgent.indexOf("windows nt 5.2") > -1) {
        version = "Windows XP";
      } else if(userAgent.indexOf("windows nt 6.0") > -1) {
        version = "Windows Vista";
      } else if(userAgent.indexOf("windows nt 6.1") > -1 || userAgent.indexOf("windows 7") > -1) {
        version = "Windows 7";
      } else if(userAgent.indexOf("windows nt 6.2") > -1 || userAgent.indexOf("windows 8") > -1) {
        version = "Windows 8";
      } else if(userAgent.indexOf("windows nt 6.3") > -1) {
        version = "Windows 8.1";
      } else if(userAgent.indexOf("windows nt 6.2") > -1 || userAgent.indexOf("windows nt 10.0") > -1) {
        version = "Windows 10";
      } else {
        version = "Unknown";
      }
    } else if(userAgent.indexOf("iphone") > -1) {
      name = "Iphone";
    } else if(userAgent.indexOf("mac") > -1) {
      name = "Mac";
    } else if(userAgent.indexOf("x11") > -1 || userAgent.indexOf("unix") > -1 || userAgent.indexOf("sunname") > -1 || userAgent.indexOf("bsd") > -1) {
      name = "Unix";
    } else if(userAgent.indexOf("linux") > -1) {
      if(userAgent.indexOf("android") > -1) {
        name = "Android"
      } else {
        name = "Linux";
      }

    } else {
      name = "Unknown";
    }
    var os = new Object();
    os.name =  name;
    os.version = version;
    return os;
    //document.write("系统：" + os.name + "版本:" + os.name)
  },
  // 设备信息
  deviceInfo() {
    let UUID = $Cookies.get('UUID');
    let deviceId = $Cookies.get('deviceId');


    let info = this.getOsInfo();
    let os = '',osVersion = '';
    info.name&&(os=info.name);
    info.version&&(osVersion=info.version);



    let params = {
      frontType: store.state.frontType,
      UUID: UUID,
      deviceId: deviceId,
      ip: '',
      clientTime: new Date().getTime(),
      isp: '',
      os: os,
      osVersion: osVersion,
      dns: '',
      dnsLocation: '',
      proxy: '',
      country: '',
      province: '',
      city: '',
      zipCode: '',
      timeZone: '',
      cookieEnable: '',
      jsEnable: '',
      flashEnable: '',
      javaEnable: '',
      activexEnable: '',
      webrtcEnable: '',
      vbEnable: '',
      adblockEnable: '',
      latitude: '',
      longitude: '',
      language: navigator.language,
      deviceMemory: '',
      maxTouchPoints: '',
      hardwareConcurrency: '',
      cpu: '',
      colorDepth: '',
      displayWidth: '',
      displayHeight: '',
    };
    $api.post($urls.HOMEAFTER.DEVIVEINFO, params, (resp) => {
      if (resp.data.code === 200) {
      } else {}
    }, err => {})
  },
};

export default commonJS



// WEBPACK FOOTER //
// ./src/common/utils/common.js